module.exports = __webpack_public_path__ + "static/media/plumbing-header@2x.4b15d765.jpg";